module.exports = {"name":"cardNotifications","audiences":["alphaMembers","allMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":0.01},"experimentVersion":"v1","defaultWeight":1,"defaults":{"showCards":false},"variations":[{"name":"showCards","weight":1,"values":{"showCards":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/cardNotifications.json
// module id = 3GOo
// module chunks = 0